import { useState } from "react";
import "@/App.css";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Translations
const translations = {
  it: {
    intro: "È il fondatore e socio titolare della <strong>Romsevi SL</strong>, una società d'eccellenza specializzata in diritto societario e operazioni transfrontaliere. Grazie alla sua doppia abilitazione forense in Italia e Spagna, Coletta funge da ponte strategico tra i due ordinamenti, operando con efficacia nelle sedi di Cassino e Madrid.",
    section1Title: "Esperienza Strategica e Hub Iberico",
    section1Text: "L'attività professionale si focalizza sulla consulenza legale aziendale mirata alla crescita e protezione del business. Attraverso la fondazione di <strong>ROMSEVI SERVICIOS PROFESIONALES SL</strong>, è stato creato un hub strategico per il mercato iberico, essenziale per garantire una governance solida e conformità normativa.",
    section2Title: "Innovazione Digitale e Legal AI",
    section2Text: "Un pilastro distintivo del profilo dell'Avvocato Coletta è la specializzazione nella Digital Innovation. È certificato <strong>\"Legal AI Competence\"</strong> attraverso corsi accreditati CNF. Questa formazione lo posiziona come esperto nella gestione delle nuove tecnologie, con un focus specifico su:",
    section2List1: "Gestione del rischio normativo legato all'imminente <strong>AI Act europeo</strong>.",
    section2List2: "Ottimizzazione operativa tramite l'automazione e il <strong>Legal Prompt Engineering</strong>.",
    section3Title: "Formazione e Competenze Trasversali",
    section3Text: "L'autorevolezza professionale poggia su basi accademiche solide, tra cui un Master alla <strong>LUISS Business School</strong> e il conseguimento del <strong>Grado en Derecho</strong>. A completare il profilo sono le competenze trasversali:",
    section3List1: "<strong>Multilinguismo</strong>: Padronanza fluida di italiano, spagnolo e inglese.",
    section3List2: "<strong>Comunicazione Efficace</strong>: Traduzione di concetti legali complessi in strategie \"actionable\".",
    contactBtn: "Contattaci",
    formTitle: "Richiedi una Consulenza",
    formName: "Nome e Cognome",
    formEmail: "Email",
    formPhone: "Telefono",
    formSubject: "Oggetto",
    formType: "Tipo di Consulenza",
    formTypeOptions: ["Diritto Societario", "Operazioni Transfrontaliere", "Legal AI", "Consulenza Generale", "Altro"],
    formMessage: "Messaggio",
    formSubmit: "Invia Richiesta",
    formSuccess: "Messaggio inviato con successo!",
    formError: "Errore nell'invio. Riprova.",
    close: "Chiudi"
  },
  es: {
    intro: "Es el fundador y socio titular de <strong>Romsevi SL</strong>, una sociedad de excelencia especializada en derecho societario y operaciones transfronterizas. Gracias a su doble habilitación forense en Italia y España, Coletta actúa como puente estratégico entre los dos ordenamientos, operando con eficacia en las sedes de Cassino y Madrid.",
    section1Title: "Experiencia Estratégica y Hub Ibérico",
    section1Text: "La actividad profesional se enfoca en la consultoría legal empresarial orientada al crecimiento y protección del negocio. A través de la fundación de <strong>ROMSEVI SERVICIOS PROFESIONALES SL</strong>, se ha creado un hub estratégico para el mercado ibérico, esencial para garantizar una gobernanza sólida y conformidad normativa.",
    section2Title: "Innovación Digital y Legal AI",
    section2Text: "Un pilar distintivo del perfil del Abogado Coletta es la especialización en Digital Innovation. Está certificado en <strong>\"Legal AI Competence\"</strong> a través de cursos acreditados CNF. Esta formación lo posiciona como experto en la gestión de nuevas tecnologías, con un enfoque específico en:",
    section2List1: "Gestión del riesgo normativo relacionado con el inminente <strong>AI Act europeo</strong>.",
    section2List2: "Optimización operativa mediante la automatización y el <strong>Legal Prompt Engineering</strong>.",
    section3Title: "Formación y Competencias Transversales",
    section3Text: "La autoridad profesional se basa en sólidas bases académicas, incluyendo un Máster en <strong>LUISS Business School</strong> y la obtención del <strong>Grado en Derecho</strong>. Completan el perfil las competencias transversales:",
    section3List1: "<strong>Multilingüismo</strong>: Dominio fluido de italiano, español e inglés.",
    section3List2: "<strong>Comunicación Eficaz</strong>: Traducción de conceptos legales complejos en estrategias \"actionable\".",
    contactBtn: "Contáctenos",
    formTitle: "Solicitar una Consulta",
    formName: "Nombre y Apellido",
    formEmail: "Correo electrónico",
    formPhone: "Teléfono",
    formSubject: "Asunto",
    formType: "Tipo de Consulta",
    formTypeOptions: ["Derecho Societario", "Operaciones Transfronterizas", "Legal AI", "Consulta General", "Otro"],
    formMessage: "Mensaje",
    formSubmit: "Enviar Solicitud",
    formSuccess: "¡Mensaje enviado con éxito!",
    formError: "Error al enviar. Inténtelo de nuevo.",
    close: "Cerrar"
  }
};

const LandingPage = () => {
  const [lang, setLang] = useState("it");
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    consultationType: "",
    message: ""
  });
  const [formStatus, setFormStatus] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const t = translations[lang];

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFormStatus(null);

    try {
      await axios.post(`${BACKEND_URL}/api/contact`, {
        ...formData,
        language: lang
      });
      setFormStatus("success");
      setFormData({
        name: "",
        email: "",
        phone: "",
        subject: "",
        consultationType: "",
        message: ""
      });
      setTimeout(() => {
        setShowModal(false);
        setFormStatus(null);
      }, 2000);
    } catch (error) {
      console.error("Error sending message:", error);
      setFormStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="landing-page" data-testid="landing-page">
      {/* Language Switcher */}
      <div className="language-switcher" data-testid="language-switcher">
        <button
          className={`lang-btn ${lang === "it" ? "active" : ""}`}
          onClick={() => setLang("it")}
          data-testid="lang-it"
        >
          IT
        </button>
        <span className="lang-divider">|</span>
        <button
          className={`lang-btn ${lang === "es" ? "active" : ""}`}
          onClick={() => setLang("es")}
          data-testid="lang-es"
        >
          ES
        </button>
      </div>

      {/* Contact Button */}
      <button 
        className="contact-btn" 
        onClick={() => setShowModal(true)}
        data-testid="contact-btn"
      >
        {t.contactBtn}
      </button>

      {/* Main Content */}
      <main className="main-content" data-testid="main-content">
        {/* Photo Section */}
        <div className="photo-section" data-testid="photo-section">
          <div className="photo-container">
            <img 
              src="https://customer-assets.emergentagent.com/job_anteprima-preview/artifacts/o8tmtila_PHOTO-2026-02-12-18-05-29%206.jpg"
              alt="Alfredo Coletta"
              className="profile-photo"
              data-testid="profile-photo"
            />
          </div>
        </div>

        {/* Text Content Section */}
        <div className="text-section" data-testid="text-section">
          <h1 className="name" data-testid="name">Alfredo Coletta</h1>
          <p className="locations" data-testid="locations">
            CASSINO • MADRID • SIVIGLIA • SANTA CRUZ DE TENERIFE
          </p>

          <p className="intro" data-testid="intro" dangerouslySetInnerHTML={{ __html: t.intro }} />

          {/* Esperienza Strategica */}
          <div className="section-block" data-testid="section-esperienza">
            <h2 className="section-title">
              <span className="title-bar"></span>
              {t.section1Title}
            </h2>
            <p className="section-text" dangerouslySetInnerHTML={{ __html: t.section1Text }} />
          </div>

          {/* Innovazione Digitale */}
          <div className="section-block" data-testid="section-innovazione">
            <h2 className="section-title">
              <span className="title-bar"></span>
              {t.section2Title}
            </h2>
            <p className="section-text" dangerouslySetInnerHTML={{ __html: t.section2Text }} />
            <ul className="section-list">
              <li dangerouslySetInnerHTML={{ __html: t.section2List1 }} />
              <li dangerouslySetInnerHTML={{ __html: t.section2List2 }} />
            </ul>
          </div>

          {/* Formazione */}
          <div className="section-block" data-testid="section-formazione">
            <h2 className="section-title">
              <span className="title-bar"></span>
              {t.section3Title}
            </h2>
            <p className="section-text" dangerouslySetInnerHTML={{ __html: t.section3Text }} />
            <ul className="section-list">
              <li dangerouslySetInnerHTML={{ __html: t.section3List1 }} />
              <li dangerouslySetInnerHTML={{ __html: t.section3List2 }} />
            </ul>
          </div>

          <div className="footer-divider" data-testid="footer-divider">
            <p className="footer-locations">
              CASSINO • MADRID • SIVIGLIA • SANTA CRUZ DE TENERIFE
            </p>
          </div>
        </div>
      </main>

      {/* Footer with two blue tones */}
      <footer className="footer" data-testid="footer">
        <div className="footer-top-bar">
          <span className="footer-brand" data-testid="footer-brand">ROMSEVI SL STUDIO LEGALE</span>
        </div>
        <div className="footer-main">
          <div className="footer-content">
            <span className="contact-label">MANTÉNGASE CONECTADO</span>
            <div className="contact-icons">
              <a href="mailto:inforomsevi@gmail.com" className="contact-email" data-testid="contact-email">
                <svg className="email-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
                inforomsevi@gmail.com
              </a>
              <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="contact-linkedin" data-testid="contact-linkedin">
                <svg className="linkedin-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/alfredocolettaavv" target="_blank" rel="noopener noreferrer" className="contact-instagram" data-testid="contact-instagram">
                <img 
                  src="https://customer-assets.emergentagent.com/job_anteprima-preview/artifacts/byuzg8i9_alfredocolettaavv_qr.png" 
                  alt="Instagram QR Code" 
                  className="instagram-qr"
                />
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Contact Modal */}
      {showModal && (
        <div className="modal-overlay" data-testid="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" data-testid="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowModal(false)} data-testid="modal-close">
              &times;
            </button>
            <h2 className="modal-title">{t.formTitle}</h2>
            
            {formStatus === "success" && (
              <div className="form-success" data-testid="form-success">{t.formSuccess}</div>
            )}
            {formStatus === "error" && (
              <div className="form-error" data-testid="form-error">{t.formError}</div>
            )}

            <form onSubmit={handleSubmit} className="contact-form" data-testid="contact-form">
              <div className="form-group">
                <label>{t.formName} *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  data-testid="form-name"
                />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>{t.formEmail} *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    data-testid="form-email"
                  />
                </div>
                <div className="form-group">
                  <label>{t.formPhone}</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    data-testid="form-phone"
                  />
                </div>
              </div>
              <div className="form-group">
                <label>{t.formSubject} *</label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  required
                  data-testid="form-subject"
                />
              </div>
              <div className="form-group">
                <label>{t.formType} *</label>
                <select
                  name="consultationType"
                  value={formData.consultationType}
                  onChange={handleInputChange}
                  required
                  data-testid="form-type"
                >
                  <option value="">--</option>
                  {t.formTypeOptions.map((opt, idx) => (
                    <option key={idx} value={opt}>{opt}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>{t.formMessage} *</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows={4}
                  required
                  data-testid="form-message"
                />
              </div>
              <button 
                type="submit" 
                className="form-submit" 
                disabled={isSubmitting}
                data-testid="form-submit"
              >
                {isSubmitting ? "..." : t.formSubmit}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

function App() {
  return <LandingPage />;
}

export default App;
